const getState = state => state.authentication;
const getToken = state => (state.authentication ? state.authentication.token : null);

export default {
  getState,
  getToken,
};
